import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchQuotaSuccess, fetchQuotaError, loadMoreQuotaSuccess, loadMoreQuotaError, addQuotaSuccess, addQuotaError} from '../actions/Quota';
import { getDocs, addDoc } from 'firebase/services/quota';
import {FETCH_QUOTA, LOAD_MORE_QUOTA, ADD_QUOTA} from 'constants/ActionTypes';

const DEFAULT_LIMIT_PAGINATION = 24;

function* fetchQuotaRequest({ params }) {
  try {
    const fetchedQuotaList = yield call(getDocs, { lastDoc: null, limit: params.limit || DEFAULT_LIMIT_PAGINATION, filter: params.filter });
    yield put(fetchQuotaSuccess(fetchedQuotaList));
  } catch (error) {
    yield put(fetchQuotaError(error));
  }
}

function* loadMoreQuotaRequest({ params }) {
  try {
    const fetchedQuotaList = yield call(getDocs, { lastDoc: params.lastDoc || null, limit: params.limit || DEFAULT_LIMIT_PAGINATION, filter: params.filter });
    yield put(loadMoreQuotaSuccess(fetchedQuotaList));
  } catch (error) {
    console.log(error);
    yield put(loadMoreQuotaError(error));
  }
}

function* addQuotaRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    // if (result && result[0] && result[0].isExist) {
    //   yield put(addQuotaError({message: 'Dữ liệu đang dùng bị trùng CRM ID. Vui lòng đổi lại CRM ID'}));
    //   return;
    // }
    yield put(addQuotaSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addQuotaError(error));
  }
}

export function* loadMoreQuota() {
  yield takeEvery(LOAD_MORE_QUOTA, loadMoreQuotaRequest);
}

export function* fetchQuota() {
  yield takeEvery(FETCH_QUOTA, fetchQuotaRequest);
}

export function* addQuota() {
  yield takeEvery(ADD_QUOTA, addQuotaRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchQuota), fork(loadMoreQuota), fork(addQuota)]);
}
